import textHelper from '@utils/textHelper';

export const EMIType = {
  DEBIT_CARD: 'Debit card',
  CARDLESS_EMI: 'Cardless',
  CREDIT_CARD: 'Credit card'
};

export const CASH_ORDER_STATUS = {
  INIT: 0,
  CANCELLED: 1,
  PAID: 2
};

const calculateMonthlyEMIAmount = (amount, months, rate) => {
  if (!rate) {
    return Math.ceil(amount / months);
  }
  const monthlyRate = rate / (12 * 100); // get monthly rate
  const calcVal = (1 + monthlyRate) ** months;
  return parseInt((amount * monthlyRate * calcVal) / (calcVal - 1), 10);
};

const getTotalDiscountText = (referral, currency) => {
  if (referral.message && referral.message.length > 0) {
    return referral.message;
  }
  if (referral.discount_type === 1 && referral.discount_value > 0) {
    return `Awesome! You got ${currency}${textHelper.commas(
      referral.discount_value
    )} off`;
  }
  if (referral.discount_type === 2 && referral.discount_percent > 0) {
    return `Awesome! You got ${referral.discount_percent}% off`;
  }
  return null;
};

const isNoCostEMIAvailable = (
  emiPlan,
  amount,
  subscriptionDuration,
  minSubsriptionDuration = 180
) => {
  return (
    emiPlan.no_cost_emi_available &&
    emiPlan.no_cost_emi_min_amount / 100 <= amount &&
    subscriptionDuration >= minSubsriptionDuration
  );
};

const daysRemainingInSubscription = (subscriptions, goalId) => {
  const currentSubscription = subscriptions?.find(
    (subscription) => subscription.subscription.value.uid === goalId
  );
  return currentSubscription?.time_remaining / (3600 * 24);
};

export default {
  calculateMonthlyEMIAmount,
  daysRemainingInSubscription,
  isNoCostEMIAvailable,
  getTotalDiscountText
};
